var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"gap-1",staticStyle:{"display":"flex"}},_vm._l((_vm.channels),function(channel){return _c('span',{key:channel,staticClass:"border border-gray-medium text-s-bold !text-gray-medium rounded-full px-2 bg-white-neutral"},[_vm._v(" "+_vm._s(_setup.getChannelTitle(channel)))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }